"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.datoToBRICKS = void 0;

var _lodash = require("lodash");

var mapDatoToBRICKS = [{
  bricksKey: 'Paragraph',
  possibleKeys: ['DatoCmsParagraph', 'ParagraphRecord']
}, {
  bricksKey: 'Elevated',
  possibleKeys: ['DatoCmsElevated', 'ElevatedRecord']
}, {
  bricksKey: 'Quote',
  possibleKeys: ['DatoCmsQuote', 'QuoteRecord']
}, {
  bricksKey: 'Gallery',
  possibleKeys: ['DatoCmsGallery', 'GalleryRecord']
}, {
  bricksKey: 'Separator',
  possibleKeys: ['DatoCmsSeparator', 'SeparatorRecord']
}, {
  bricksKey: 'Hero',
  possibleKeys: ['DatoCmsHero', 'HeroRecord']
}, {
  bricksKey: 'Headline',
  possibleKeys: ['DatoCmsHeadline', 'HeadlineRecord']
}, {
  bricksKey: 'Images',
  possibleKeys: ['DatoCmsImages', 'ImagesRecord', 'DatoCmsImage', 'ImageRecord']
}, {
  bricksKey: 'Interview',
  possibleKeys: ['DatoCmsInterview', 'InterviewRecord']
}, {
  bricksKey: 'Video',
  possibleKeys: ['DatoCmsVideo', 'VideoRecord']
}, {
  bricksKey: 'Marquee',
  possibleKeys: ['DatoCmsMarquee', 'MarqueeRecord']
}, {
  bricksKey: 'Credits',
  possibleKeys: ['DatoCmsCredits', 'CreditsRecord']
}, {
  bricksKey: 'CTA',
  possibleKeys: ['DatoCmsCTA', 'CTARecord', 'CtaRecord', 'DatoCmsCta']
}, {
  bricksKey: 'ShoppingGallery',
  possibleKeys: ['DatoCmsShoppingCarousel', 'ShoppingCarouselRecord']
}, {
  bricksKey: 'AgeGate',
  possibleKeys: ['DatoCmsAgeGate', 'AgeGateRecord']
}];

var datoToBRICKS = function datoToBRICKS(_ref) {
  var content = _ref.content;
  var storyContent = [];
  var currentLayout = null;
  (0, _lodash.forEach)(content, function (item, index) {
    var t = item.__typename;

    if ((0, _lodash.includes)(t, 'Layout')) {
      currentLayout = currentLayout === null ? 0 : currentLayout + 1;
      var layout = {};
      layout.type = item.layoutType;
      layout.data = (0, _lodash.omit)(item, ['id', '__typename', 'layoutType', 'backgroundImage']);

      if (item.backgroundImage) {
        layout.data.backgroundImage = item.backgroundImage.responsiveImage || item.backgroundImage.fluid;
      }

      layout.elements = [];
      storyContent.push(layout);
    } else {
      if (index === 0) {
        currentLayout = 0;
        var _layout = {};
        _layout.type = 'Simple';
        _layout.data = {};
        _layout.elements = [];
        storyContent.push(_layout);
      }

      var elType = null;
      (0, _lodash.forEach)(mapDatoToBRICKS, function (k) {
        if ((0, _lodash.includes)(k.possibleKeys, t)) {
          elType = k.bricksKey;
        }
      });
      console.log('el type ', elType);
      var element = {};
      element.type = elType;
      element.data = (0, _lodash.omit)(item, ['__typename', 'id']);

      if (item.backgroundImage) {
        element.data.backgroundImage = item.backgroundImage.responsiveImage || item.backgroundImage.fluid;
      }

      if (item.svgPortrait) {
        element.data.svgPortrait = item.svgPortrait.url;
      }

      if (item.svgLandscape) {
        element.data.svgLandscape = item.svgLandscape.url;
      }

      if (item.items) {
        element.data.items = (0, _lodash.map)(item.items, function (it) {
          return it.fluid || it.responsiveImage;
        });
      }

      if (item.images) {
        element.data.images = (0, _lodash.map)(item.images, function (it) {
          return it.fluid || it.responsiveImage;
        });
      }

      if (element.type !== null) {
        storyContent[currentLayout].elements.push(element);
      } else {
        console.log('No matching element type found for ', item, t, mapDatoToBRICKS);
      }
    }
  });
  return storyContent;
};

exports.datoToBRICKS = datoToBRICKS;
var _default = datoToBRICKS;
exports.default = _default;